export default class MobileMenu {

    constructor() {
        this.settings = {
            $openButton: $('.js-off-canvas-open-submenu'),
            $closeButton: $('.js-off-canvas-close-submenu'),
        };
        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$openButton.length) {
            this.settings.$openButton.on('click', function(e) {
                e.preventDefault();
                const $subMenu = $(this).closest('li').find('.js-off-canvas-submenu').first();
                $subMenu.removeClass('hidden');
                $('.js-header-buttons').addClass('hidden');
            });
        }

        if (this.settings.$closeButton.length) {
            this.settings.$closeButton.on('click', function(e) {
                e.preventDefault();
                const $subMenu = $(this).closest('.js-off-canvas-submenu');
                $subMenu.addClass('hidden');
                $('.js-header-buttons').removeClass('hidden');
            });
        }

    }

};

new MobileMenu();
